// src/constants/expositorTypes.ts

export interface ExpositorType {
  id: string;
  name: string;
  description: string;
  calculateSurface?: (w: number, h: number, d: number, params: any) => number;
  parameters?: Array<{
    id: string;
    name: string;
    type: 'number' | 'boolean' | 'select';
    min?: number;
    max?: number;
    default?: any;
    options?: Array<{ value: any; label: string }>;
  }>;
}

export const EXPOSITOR_TYPES: Record<string, ExpositorType> = {
  podstawkowy: {
    id: 'podstawkowy',
    name: 'Podstawkowy',
    description: 'Podstawa + plecy + boki + opcjonalny topper',
    calculateSurface: (w: number, h: number, d: number, params: any) => {
      const base = w * d;
      const back = w * h;
      const sides = params.withSides ? 2 * (d * h) : 0;
      const topper = params.withTopper ? w * (h * 0.2) : 0;
      return base + back + sides + topper;
    },
    parameters: [
      { id: 'withSides', name: 'Dodaj boki', type: 'boolean', default: true },
      { id: 'withTopper', name: 'Dodaj topper', type: 'boolean', default: false }
    ]
  },
  
  schodkowy: {
    id: 'schodkowy',
    name: 'Schodkowy',
    description: '3-5 półek stopniowanych',
    calculateSurface: (w: number, h: number, d: number, params: any) => {
      const baseArea = w * d;
      const backArea = w * h;
      const sidesArea = 2 * (d * h);
      const shelves = params.shelves || 3;
      const stepArea = shelves * w * (d / shelves);
      const risers = shelves * w * 0.05; // wysokość podstopnic
      return baseArea + backArea + sidesArea + stepArea + risers;
    },
    parameters: [
      { id: 'shelves', name: 'Liczba półek', type: 'number', min: 2, max: 5, default: 3 }
    ]
  },
  
  z_haczykami: {
    id: 'z_haczykami',
    name: 'Z haczykami',
    description: 'Płyta perforowana pod haczyki',
    calculateSurface: (w: number, h: number, d: number, params: any) => {
      const base = w * d;
      const back = w * h; // płyta perforowana
      const sides = 2 * (d * h);
      const topper = params.topper ? w * (h * 0.2) : 0;
      return base + back + sides + topper;
    },
    parameters: [
      { id: 'hookRows', name: 'Rzędy haczyków', type: 'number', min: 1, max: 10, default: 3 },
      { id: 'hookCols', name: 'Kolumny haczyków', type: 'number', min: 1, max: 10, default: 4 }
    ]
  },
  
  wiszacy: {
    id: 'wiszacy',
    name: 'Wiszący',
    description: 'Montowany na ścianie',
    calculateSurface: (w: number, h: number, d: number, params: any) => {
      const backPanel = w * h;
      const pockets = (params.pockets || 3) * w * 0.1; // kieszenie na ulotki
      return backPanel + pockets;
    },
    parameters: [
      { id: 'pockets', name: 'Liczba kieszeni', type: 'number', min: 0, max: 10, default: 3 }
    ]
  },
  
  stojak: {
    id: 'stojak',
    name: 'Stojak reklamowy',
    description: 'Wolnostojący z podstawą',
    calculateSurface: (w: number, h: number, d: number, params: any) => {
      const heavyBase = w * d * 1.5; // grubsza podstawa dla stabilności
      const frame = 2 * (h * 0.1); // rama nośna
      const shelves = (params.shelves || 3);
      const segments = shelves * w * 0.2;
      return heavyBase + frame + segments;
    },
    parameters: [
      { id: 'shelves', name: 'Liczba półek', type: 'number', min: 1, max: 5, default: 3 }
    ]
  },
  
  kosmetyczny: {
    id: 'kosmetyczny',
    name: 'Kosmetyczny',
    description: 'Półki z ogranicznikami',
    calculateSurface: (w: number, h: number, d: number, params: any) => {
      const base = w * d;
      const back = w * h;
      const sides = 2 * (d * h);
      const shelves = (params.shelves || 3) * w * d;
      const dividers = (params.shelves || 3) * (params.partitions || 0) * d * 0.08;
      return base + back + sides + shelves + dividers;
    },
    parameters: [
      { id: 'shelves', name: 'Liczba półek', type: 'number', min: 1, max: 5, default: 3 },
      { id: 'partitions', name: 'Przegrody na półkę', type: 'number', min: 0, max: 5, default: 2 }
    ]
  }
};